import {fetchJSONByGet, fetchJSONByPost, fetchJSONByPut, fetchJSONByDel} from './index.js'
// 获得保险公司客户信息分页
export const companyPageApi = (params) => fetchJSONByGet('/admin-api/ins/company/page', params)
// 创建保险公司客户信息
export const companyCreateApi = (body) => fetchJSONByPost('/admin-api/ins/company/create', body)
// 更新保险公司客户信息
export const companyUpdateApi = (body) => fetchJSONByPut('/admin-api/ins/company/update', body)
// 获得商家商品页面分页
export const productPageApi = (params) => fetchJSONByGet('/admin-api/ins/product/page', params)
// 批量删除商家商品页面
export const delProductsApi = (ids) => fetchJSONByDel(`/admin-api/ins/product/batch/delete?ids=${ids.join(',')}`, {data: {ids}})
// 批量更新商家商品页面
export const updateProductsApi = (body) => fetchJSONByPut('/admin-api/ins/product/batch/update', body)
// 查询用户余额及明细
export const getAccountBalanceApi = (params) => fetchJSONByGet('/admin-api/ins/cargo-order-request/balance', params)
// 创建批单申请
export const createCargoOrderApi = (body) => fetchJSONByPost('/admin-api/ins/cargo-order-request/create', body)
// 计算批单保费
export const calcCargoOrderApi = (body) => fetchJSONByPost('/admin-api/ins/cargo-order-request/calc', body)
// 获得批单申请分页
export const cargoOrderPageApi = (params) => fetchJSONByGet('/admin-api/ins/cargo-order-request/page', params)
// 批单申请确认
export const cargoOrderConfirmApi = (id) => fetchJSONByPost(`/admin-api/ins/cargo-order-request/approval/${id}`)
// 取消批单
export const cargoOrderCancelApi = (id) => fetchJSONByPost(`/admin-api/ins/cargo-order-request/cancel/${id}`)
// 查询保单（批单）
export const cargoOrderApi = (id) => fetchJSONByGet(`/admin-api/ins/cargo-order-request/${id}`)
// 修改批单申请
export const cargoOrderUpdateApi = (id, body) => fetchJSONByPost(`/admin-api/ins/cargo-order-request/update/${id}`, body)
// 取消凭证
export const cargoOrderPolicyCancelApi = (id) => fetchJSONByPost(`/admin-api/ins/cargo-order-request/policyCancel/${id}`)
// 获得交易订单分页
export const orderPageApi = (params) => fetchJSONByGet('/admin-api/ins/order/page', params)
// 获取交易订单发票
export const getOrderInvoiceApi = (body) => fetchJSONByPost(`/admin-api/ins/order/applyInvoice`, body)
// 用户追踪
export const userTrackApi = (body) => fetchJSONByPost('/admin-api/ins/tracking/log', body)
// 获取等级
export const getRateInfoApi = () => fetchJSONByGet('/admin-api/ins/company/cargoAgent/rate/info')
// 获得凭证历史
export const cargoOrderActionHistoryApi = (id) => fetchJSONByGet(`/admin-api/ins/cargo-order-request/history/${id}`)

